import React from "react";

const External = () => (
<svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1L8.07107 1L8.07107 8.07107" stroke="#00F37A" strokeWidth="1.5"/>
<path d="M8 1L1 8" stroke="#00F37A" strokeWidth="1.5"/>
</svg>
);

export default External;
